import { ExternalMessageInbox } from "@/Common/Models/ExternalCommunications/GridExternalMessage";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";

class ExternalMessageInboxTableItem implements ITableDataSourceItem<ExternalMessageInbox> {
    public Model: ExternalMessageInbox;
    public IsSelected: boolean;
    public Name: string;

    constructor(model: ExternalMessageInbox) {
        this.Model = model;
        this.IsSelected = false;
    }
}

export { ExternalMessageInboxTableItem };
